import {BooleanField, Datagrid, ListProps, NullableBooleanInput, TextField} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {IdentifierField} from "../../components/IdentifierField";
import {SubjectField} from "../../components/SubjectField";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../../shared/utils";

export const UserClientList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");

  const filters = options
    ? [
      <NullableBooleanInput {...initField("is_active", options)} />
    ]
    : [];

  return options ? (
    <CustomList
      filters={filters}
      {...getDefaultListProps(props)}
      filterDefaultValues={{ is_active: true }}
    >
      <Datagrid>
        <IdentifierField {...initField("id", options)} />
        <TextField {...initField("username", options)} />
        <SubjectField {...initField("client_object", options)} />
        <BooleanField {...initField("is_active", options)} />
        <BooleanField {...initField("order_permission", options)} />
        <BooleanField {...initField("tracking_permission", options)} />
        <BooleanField {...initField("is_sender", options)} />
      </Datagrid>
    </CustomList>
  ) : null;
};
